// extracted by mini-css-extract-plugin
export default {"container":"qPMmGE","isResized":"fCMihS","slider":"L9sska","empty":"HlW7T_","emptyContent":"pwQZhO","navButton":"xY5oyb","shadyNav":"RP9F9r","player":"Oxc3vO","active":"aaYNls"};